import React from 'react'
import {ServerConfig} from 'config'

import NonPaginatedList from '../../components/EntryListAndEdit/NonPaginatedList'


const Subaccounts = () => {
  const non_editable_fields = [
    ["id", "id", ""],
  ];

  const editable_fields = [
    ["first_name", "First Name"],
    ["last_name", "Last Name"],
    ["street", "Street"],
    ["city", "City"],
    ["zipcode", "Zipcode"],
    ["state", "State"],
    ["email", "Email"],
    ["phone_number", "Phonenumber"],
    ["password", "Password"],
    ["role", "Role", "select", ["User", "Admin"]],
  ];

  return (
    <>
      <NonPaginatedList
        list_get_url={`${ServerConfig.SERVER_URL}/tenant/subaccounts`}
        detail_get_url={`${ServerConfig.SERVER_URL}/tenant/subaccount/`}
        detail_put_url={`${ServerConfig.SERVER_URL}/tenant/subaccount/`}
        detail_delete_url={`${ServerConfig.SERVER_URL}/tenant/subaccount/`}
        add_new_url={`${ServerConfig.SERVER_URL}/tenant/subaccount`}

        column_names={["first_name", "last_name", "role"]}
        header_names={["First Name", "Last Name", "Role"]}

        optional_column_names={["email"]}
        optional_header_names={["Email"]}

        editable_fields={editable_fields}
        non_editable_fields={non_editable_fields}
      />
    </>
  )
}

export default Subaccounts
